import type { EntityType } from '../../domain/labels.js';
import { SYNC_STATUS, type SyncStatus } from '../../domain/status.js';
import type { OpenTarget } from './types.js';

/** One environment cell of a row — a grid's status cell, a card's pill. */
export type CellTarget = { environment: string; status: SyncStatus; label: string; target: OpenTarget };

/**
 * One per column, in column order: the row's own status there (`unknown` where it has no cell),
 * what a screen reader hears, and what opening it focuses.
 */
export const cellTargets = (
    columns: readonly { name: string }[],
    cells: Record<string, { status: SyncStatus } | undefined>,
    type: EntityType,
    key: string,
    name: string,
): CellTarget[] =>
    columns.map(({ name: environment }) => {
        const status = cells[environment]?.status ?? 'unknown';
        return {
            environment,
            status,
            label: `${name} in ${environment}: ${SYNC_STATUS[status].label}`,
            target: { type, key, environment },
        };
    });
